import React, { useState } from "react";
import Navbar from "./Navbar";
import pricingbg from "../assets/pricing.png";

function LedgerPro() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    email: '',
    mobileNumber: '',
    message: '',
    numberOfFiles: '1'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const calculateTotal = () => {
    const numFiles = parseInt(formData.numberOfFiles) || 1;
    return numFiles * 35;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const submissionData = {
      ...formData,
      totalAmount: calculateTotal(),
      serviceType: "Ledger Pro - MYOB ↔ Xero Bidirectional Conversion Tool"
    };
    
    try {
      const response = await fetch('https://api-issp7n7t4a-uc.a.run.app/api/premimum-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(submissionData)
      });

      if (response.ok) {
        alert('Thank You! Your access to Ledger Pro will be activated shortly. You will receive login credentials via email.');
        handleDialogClose();
        // Reset form data
        setFormData({
          name: '',
          companyName: '',
          email: '',
          mobileNumber: '',
          message: '',
          numberOfFiles: '1'
        });
      } else {
        alert('Failed to submit the form. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white text-black min-h-screen flex flex-col mt-20" style={{
      backgroundImage: `url(${pricingbg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
    >
      <Navbar />

      <div className="flex-1">
        <div className="mx-auto mt-9 max-w-7xl px-6 lg:px-9">
          <div className="mx-auto max-w-4xl sm:text-center">
            <h2 className="text-3xl text-white font-bold tracking-tight sm:text-4xl">
              Ledger Pro: Bidirectional MYOB ↔ Xero Conversion Tool
            </h2>
            <p className="mt-6 text-lg text-white leading-8">
              Convert between MYOB and Xero formats instantly with our automated conversion tool. 
              Fast, accurate, and secure - no technical expertise required.
            </p>
          </div>
          
          <div className="mt-16 flex justify-center pb-12">
            {/* Single Pricing Card with Both Options */}
            <div className="bg-black text-white bg-opacity-90 rounded-3xl p-8 max-w-lg w-full">
              <div className="flex items-center gap-x-2 mb-4">
                <h3 className="text-2xl font-bold">Ledger Pro Tool Access</h3>
                <span className="text-xs text-indigo-400 font-semibold bg-indigo-900 px-2 py-1 rounded-full">BIDIRECTIONAL</span>
              </div>
              
              <p className="mt-4 text-base leading-7 text-gray-300">
                Self-service tool for converting between MYOB and Xero formats. Upload your files and get 
                converted files in minutes. Perfect for accountants, bookkeepers, and business owners.
              </p>
              
              {/* Conversion Options */}
              <div className="mt-6 grid grid-cols-2 gap-4">
                <div className="bg-gray-800 rounded-lg p-4 text-center">
                  <div className="text-indigo-400 text-lg mb-2">MYOB → Xero</div>
                  <p className="text-xs text-gray-400">Convert MYOB files to Xero format</p>
                </div>
                <div className="bg-gray-800 rounded-lg p-4 text-center">
                  <div className="text-green-400 text-lg mb-2">Xero → MYOB</div>
                  <p className="text-xs text-gray-400">Convert Xero files to MYOB format</p>
                </div>
              </div>
              
              <div className="mt-8 flex items-center gap-x-4">
                <h4 className="text-sm font-semibold text-indigo-400">
                  Tool Features
                </h4>
                <div className="h-px flex-auto bg-gray-700"></div>
              </div>
              
              <ul role="list" className="mt-6 text-sm leading-6 space-y-4">
                <li className="flex gap-x-3 items-start">
                  <span className="text-indigo-400 text-lg">🔄</span>
                  <div>
                    <span className="font-medium">Bidirectional Conversion</span>
                    <p className="text-gray-400 text-xs mt-1">Convert both MYOB to Xero and Xero to MYOB</p>
                  </div>
                </li>
                <li className="flex gap-x-3 items-start">
                  <span className="text-indigo-400 text-lg">⚡</span>
                  <div>
                    <span className="font-medium">Instant Conversion</span>
                    <p className="text-gray-400 text-xs mt-1">Convert files in under 5 minutes</p>
                  </div>
                </li>
                <li className="flex gap-x-3 items-start">
                  <span className="text-indigo-400 text-lg">📊</span>
                  <div>
                    <span className="font-medium">Batch Processing</span>
                    <p className="text-gray-400 text-xs mt-1">Convert multiple files simultaneously</p>
                  </div>
                </li>
                <li className="flex gap-x-3 items-start">
                  <span className="text-indigo-400 text-lg">✓</span>
                  <div>
                    <span className="font-medium">Automatic Data Mapping</span>
                    <p className="text-gray-400 text-xs mt-1">Smart mapping of accounts, contacts, and transactions</p>
                  </div>
                </li>
                <li className="flex gap-x-3 items-start">
                  <span className="text-indigo-400 text-lg">🔒</span>
                  <div>
                    <span className="font-medium">Secure Platform</span>
                    <p className="text-gray-400 text-xs mt-1">Your data is encrypted and automatically deleted after processing</p>
                  </div>
                </li>
                <li className="flex gap-x-3 items-start">
                  <span className="text-indigo-400 text-lg">💾</span>
                  <div>
                    <span className="font-medium">Multiple Format Support</span>
                    <p className="text-gray-400 text-xs mt-1">Supports various MYOB and Xero file versions</p>
                  </div>
                </li>
              </ul>
              
              <div className="mt-10 text-center border-t border-gray-700 pt-6">
                <div className="mb-4">
                  <p className="text-sm text-gray-400">Pay per conversion (both directions)</p>
                  <p className="text-4xl font-bold text-white">$35<span className="text-lg font-normal text-gray-300"> / file</span></p>
                  <p className="text-sm text-gray-400 mt-1">No subscription fees • Volume discounts available</p>
                </div>
                <button
                  className="mt-4 bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-8 rounded-lg font-semibold transition duration-300 w-full"
                  onClick={handleDialogOpen}
                >
                  Get Tool Access Now
                </button>
                <p className="text-xs text-gray-500 mt-4">Access both conversion directions • Instant activation</p>
              </div>
            </div>
          </div>

          {/* How It Works Section */}
          <div className="mt-12 bg-black bg-opacity-70 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white text-center mb-8">How Ledger Pro Works</h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2 font-bold">1</div>
                <h4 className="font-semibold text-white">Upload File</h4>
                <p className="text-gray-400 text-sm mt-2">Upload your MYOB or Xero file to our secure platform</p>
              </div>
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2 font-bold">2</div>
                <h4 className="font-semibold text-white">Choose Direction</h4>
                <p className="text-gray-400 text-sm mt-2">Select conversion direction (MYOB→Xero or Xero→MYOB)</p>
              </div>
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2 font-bold">3</div>
                <h4 className="font-semibold text-white">Auto-Convert</h4>
                <p className="text-gray-400 text-sm mt-2">Our tool automatically converts all data between formats</p>
              </div>
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2 font-bold">4</div>
                <h4 className="font-semibold text-white">Download</h4>
                <p className="text-gray-400 text-sm mt-2">Download converted files and import into your accounting software</p>
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="mt-12 bg-black bg-opacity-70 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white text-center mb-6">Why Choose Our Tool?</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2">🔄</div>
                <h4 className="font-semibold text-white">Bidirectional</h4>
                <p className="text-gray-400 text-sm mt-2">Convert both ways - MYOB to Xero and Xero to MYOB</p>
              </div>
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2">⚡</div>
                <h4 className="font-semibold text-white">Instant Results</h4>
                <p className="text-gray-400 text-sm mt-2">No waiting - get converted files in minutes, not days</p>
              </div>
              <div className="text-center p-4">
                <div className="text-indigo-400 text-3xl mb-2">💸</div>
                <h4 className="font-semibold text-white">Cost Effective</h4>
                <p className="text-gray-400 text-sm mt-2">Pay only for what you convert, no hidden fees</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Access Request Modal */}
      {isDialogOpen && (
  <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center p-4 z-50 mt-20">
    <div className="bg-white p-6 rounded-lg max-w-4xl w-full shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-blue-600">Get Ledger Pro Access</h2>
        <button
          onClick={handleDialogClose}
          className="text-gray-500 hover:text-gray-700 text-xl"
        >
          ×
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column - Pricing & Conversion Options */}
        <div>
          <div className="mb-6 p-4 bg-blue-50 rounded-lg">
            <div className="flex justify-between items-center mb-3">
              <div>
                <p className="text-sm text-gray-600">Tool Access Cost:</p>
                <p className="text-2xl font-bold text-blue-700">${calculateTotal()} AUD</p>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-600">Files: {formData.numberOfFiles} × $35</p>
                <p className="text-xs text-gray-500">Pay per conversion credits</p>
              </div>
            </div>
            
            <div className="mt-4">
              <h3 className="text-sm font-medium text-gray-700 mb-2">Conversion Directions Included:</h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-white border border-indigo-200 rounded-lg p-3 text-center">
                  <div className="text-indigo-600 font-semibold mb-1">MYOB → Xero</div>
                  <p className="text-xs text-gray-600">Convert MYOB files to Xero format</p>
                </div>
                <div className="bg-white border border-green-200 rounded-lg p-3 text-center">
                  <div className="text-green-600 font-semibold mb-1">Xero → MYOB</div>
                  <p className="text-xs text-gray-600">Convert Xero files to MYOB format</p>
                </div>
              </div>
            </div>
            
            <div className="mt-4 pt-4 border-t border-blue-100">
              <div className="flex items-start space-x-2">
                <span className="text-green-500">✓</span>
                <p className="text-xs text-gray-600">Access both conversion directions</p>
              </div>
              <div className="flex items-start space-x-2 mt-1">
                <span className="text-green-500">✓</span>
                <p className="text-xs text-gray-600">Credits never expire</p>
              </div>
              <div className="flex items-start space-x-2 mt-1">
                <span className="text-green-500">✓</span>
                <p className="text-xs text-gray-600">No subscription fees</p>
              </div>
            </div>
          </div>
          
          {/* Credits Selection */}
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-medium mb-2">Select Number of Conversion Credits</label>
            <div className="grid grid-cols-5 gap-2">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                <button
                  key={num}
                  type="button"
                  onClick={() => setFormData({...formData, numberOfFiles: num.toString()})}
                  className={`py-3 rounded-lg text-center transition duration-200 ${
                    formData.numberOfFiles === num.toString() 
                      ? 'bg-blue-600 text-white' 
                      : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                  }`}
                >
                  <div className="font-semibold">{num}</div>
                  <div className="text-xs mt-1">${num * 35}</div>
                </button>
              ))}
            </div>
            <select
              name="numberOfFiles"
              value={formData.numberOfFiles}
              onChange={handleInputChange}
              required
              className="w-full mt-4 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="10+">10+ conversions (Contact for enterprise pricing)</option>
            </select>
            <p className="text-xs text-gray-500 mt-2">Each credit works for both conversion directions</p>
          </div>
        </div>

        {/* Right Column - Contact Form */}
        <div>
          <form onSubmit={handleSubmit}>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Contact Information</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Your Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Company Name</label>
                <input
                  type="text"
                  placeholder="Company name"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Email Address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Phone Number</label>
                <input
                  type="tel"
                  placeholder="Phone number"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-medium mb-1">Additional Requirements</label>
              <textarea
                name="message"
                placeholder="Tell us about your conversion needs, specific requirements, or timeline..."
                value={formData.message}
                onChange={handleInputChange}
               
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">Optional: Let us know if you have specific MYOB versions or requirements</p>
            </div>
            
            <div className="space-y-3">
              <button
                type="submit"
                className={`w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg font-semibold transition duration-300 ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Processing..." : `Get Access Now - $${calculateTotal()} AUD`}
              </button>
              <button
                type="button"
                className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 py-3 px-4 rounded-lg font-medium transition duration-300"
                onClick={handleDialogClose}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default LedgerPro;